const getRedirectLocation = (response, key = 0) => {
    let location = null;

    if (
        response &&
        response.status === 301 &&
        response.headers &&
        response.headers.valid_locations
    ) {
        const locations = JSON.parse(response.headers.valid_locations);

        if (locations && locations[key]) {
            location = locations[key];
        }
    }

    return location;
};

export default getRedirectLocation;
